import { Pill } from "src/base-components/Pill";
import { UserStatus } from "src/userManagement/types";
import { assertUnreachable } from "src/utils/typeUtils";

export const Status: React.FC<{ status: UserStatus; dataLoc: string }> = ({
  status,
  dataLoc,
}) => {
  const variant = (() => {
    switch (status) {
      case "active":
        return "green";

      case "deactivated":
        return "red";

      case "invited":
        return "gray";

      default:
        assertUnreachable(status);
    }
  })();

  return (
    <Pill fontType="text" dataLoc={dataLoc} size="sm" variant={variant}>
      <Pill.Text>{status}</Pill.Text>
    </Pill>
  );
};
